<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{name:'incidencias-operarios'}">{{$t("incidenciaOperario")}}</router-link></li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("incidencias")}} {{nameOperario}}</li>
                    </ol>
                </nav>
            </div>
          <!--  <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="false"
            />-->

            <template v-if="respuesta">
                <div class="col-md-8" >
                    <template v-if="list.length>0">
                    <div><span style="font-size: 1.5em;">{{$t("incidencias")}} {{nameOperario}}</span></div>
                    <div style="margin-top: 10px; margin-bottom: 10px;">
                        <router-link :to="{name:'incidencias-operarios'}" class="btn btn-primary"><i
                                class="fas fa-arrow-circle-left"></i>
                            {{$t("volverALaLista")}}
                        </router-link>
                    </div>
                        <!--<div class="row justify-content-between div-export">

                           <div class="col-md-2 col-xs-12 text-right">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong>
                                                    <i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}
                                                </strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>-->
                        <div class="table-responsive ">
                            <table class="table table-bordered table-striped text-nowrap " >
                                <thead class="thead-dark">
                                <tr style="cursor: pointer;">
                                     <th v-if="ordenacionFecha===0" @click="sortedArrayFechaASC('Fecha')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("fecha")}}
                                    </th>
                                    <th v-else @click="sortedArrayFechaDESC('Fecha')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("fecha")}}
                                    </th>
                                    <th v-if="ordenarIssues===0" @click="sortedArrayIssuesASC('numIssues')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("incidencia")}}
                                    </th>
                                    <th v-else @click="sortedArrayIssuesDESC('numIssues')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("incidencia")}}
                                    </th>
                                    <th v-if="ordenarImporte===0" @click="sortedArrayCosteASC('Coste')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                    </th>
                                    <th v-else @click="sortedArrayCostesDESC('Coste')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                    </th>

                                    <th><i
                                            style="color: white"></i> {{$t("ticket")}}
                                    </th>
                                    
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="obj in list">
                                     <td class="text-left">{{obj.Fecha}}</td>
                                    <td class="text-center">
                                        
                                        <div  v-tooltip="'Esto es una cuenta anulada'" v-if="obj.Tipo == 'A'" > 
                                            <button  @click="openModal(obj)" class="btn cuentaIncidencia" disabled = "disabled">
                                                {{obj.numIssues}} <i class="fa fa-eye cuentaIncidenciaIcon"></i>
                                            </button>
                                        </div>
                                    
                                        
                                        <div v-else><button  @click="openModal(obj)" class="btn cuentaIncidencia">
                                            {{obj.numIssues}} <i class="fa fa-eye cuentaIncidenciaIcon"></i>
                                        </button></div>
                                    </td>
                                    <td v-if="obj.Coste > 0" class="text-left table-success">{{obj.Coste | currency}}</td>
                                    <td v-else class="text-left table-danger">{{obj.Coste | currency}}</td>
                                    <td class="text-center">
                                    <button @click="getDetTicketsById(obj.idHeader, obj.Ticket)" class="btn Ticketbtn" v-tooltip.top-center="$i18n.t('verDetallesDetTicket')">
                                        <i class="fa fa-eye "></i>
                                    </button>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td class="text-center"><strong>{{getTotalIncidencias}}</strong></td>
                                    <td class="text-left"><strong>{{getTotalCoste | currency }}</strong></td>
                                    <td></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{$t("noHay")}} <strong>{{$t('incidenciaOperario')}}</strong> {{$t("rangoDeFechas")}}
                        </div>
                    </template>
                </div>

               <!-- <div class="col-md-7 ">
                    <div class="card">
                        <div class="chart-container col-md-12 " style="height:40vh;">
                            <canvas id="chart"></canvas>
                        </div>

                    </div>
                </div>-->
            </template>
        </div>

    <modal
      :name="'modal-incidencias'"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("incidencias") }} </h4>
          <i class="fa fa-times" aria-hidden="true" style="color: red" @click="closeModalIncidencia()"></i>
        </div>
        <div class="modal-body" style="background-color: #f5f5f5">
          <pre>{{issue}}</pre>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button
              class="btn btn-danger"
              @click="closeModalIncidencia()"
            >
              <i class="fa fa-window-close"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="desglose-ticket-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("desgloseDelTicket") }} {{ nameTickets }}
          </h4>
        </div>
        <div class="modal-body">
          <ticket :ticket="listDesgloseTicket"></ticket>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="cerrarModal()">
            <i class="fa fa-times-circle"></i>
            {{ $t("volver") }}
          </button>
        </div>
      </div>
    </modal>

    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import Ticket from "../../../Widgets/Ticket.vue";
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading} from 'element-ui'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t('incidenciaOperario'));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }

          /*  */

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            ticket: Ticket,
            CabeceraInformes
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                mode: 0,
                objectChart: null,
                contador: 0,
                listTpv: [],
                //idTpv: -1,
                dateRangeOptions1: {
                    firstDayOfWeek: 1
                },

                ordenacionOperario: 0,
                ordenarImporte: 0,
                ordenarInvitations: 0,
                ordenarDifHora: 0,
                ordenarSueldo: 0,
                ordenarEfectivo:0,
                ordenarTarjeta:0,
                ordenarCheque:0,
                ordenarIssues: 0,
                ordenacionFecha:0,

                respuesta: true,
                nameOperario:this.$route.params.workerName,
                idTpv : this.$route.params.idTpv,
                issue: "",
                listDesgloseTicket: [],

            }
        },
        computed: {
            

            getTotalIncidencias() {
                let total = 0;
                this.list.forEach(function (d) {
                  
                         total += d.numIssues;
                    
                   
                });
                return total;
            },

            getTotalCoste() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.Coste; 
                });
                return total;
            },
        },
        methods: {

            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                
                
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.list = [];
                this.cambioTpv(this.idTpv);
            },
            openModal(object) {
                this.issue = object.Issues;
                this.$modal.show("modal-incidencias");
                
            },
            closeModalIncidencia() {
                this.issue = "";
                this.$modal.hide("modal-incidencias");
                
            },
            cerrarModal(){
                this.$modal.hide("desglose-ticket-modal");
            },

            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                this.getIussesOperarios(); 
            },

            cambioTpv(idTpvData, filtrar) {

                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                }
                
                this.idTpv=idTpvData;
                this.emitirConsulta();
            },

            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]
            },

            sortedArrayCosteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.Coste < b.Coste)
                        return -1;
                    if (a.Coste > b.Coste)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCostesDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.Coste > b.Coste)
                        return -1;
                    if (a.Coste < b.Coste)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            
            sortedArrayIssuesASC: function () {
                this.ordenarIssues = 1;

                function compare(a, b) {
                    if (a.numIssues < b.numIssues)
                        return -1;
                    if (a.numIssues > b.numIssues)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayIssuesDESC: function () {
                this.ordenarIssues = 0;

                function compare(a, b) {

                    if (a.numIssues > b.numIssues)
                        return -1;
                    if (a.numIssues < b.numIssues)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
             sortedArrayFechaASC: function () {
                this.ordenacionFecha = 1;
                let vm = this;
                function compare(a, b) {
                    let fecha1 = vm.FormateadorFecha(a.Fecha);
                    let fecha2 = vm.FormateadorFecha(b.Fecha);
                    
                    if (fecha1 <  fecha2)
                        return -1;
                    if (fecha1 > fecha2)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayFechaDESC: function () {
                this.ordenacionFecha = 0;
                let vm = this;
                function compare(a, b) {
                    let fechaa = vm.FormateadorFecha(a.Fecha);
                    let fechab = vm.FormateadorFecha(b.Fecha);
                    if (fechaa >fechab)
                        return -1;
                    if (fechaa < fechab)
                        return 1;
                    return 0;
                }
                return this.list.sort(compare);
            },
            FormateadorFecha(fechan){
                let fecha = fechan.split(" ")[0];
                   let tiempo = fechan.split(" ")[1];
                   let anyo = "";
                   let dia = "";
                   let mes = "";
                   
                   if (fecha.includes("-")) {
                    dia = fecha.split("-")[1];
                    mes = fecha.split("-")[0];
                    anyo = fecha.split("-")[2];
                   }

                   if (fecha.includes("/")) {
                    dia = fecha.split("/")[1];
                    mes = fecha.split("/")[0];
                    anyo = fecha.split("/")[2];
                   }

                   let hora = "";
                   let minutos = "";
                   hora = tiempo.split(":")[0];
                   minutos = tiempo.split(":")[1];
                    //let fechaMal = new Date(a.Fecha);
                    
                    // console.log(mes);
                    let fechaFormateada = [];

                    fechaFormateada = dia + "/" + mes + "/" + anyo + " " + hora + ":" + minutos;
                    // console.log(fechaFormateada);
                    // console.log(new Date(fechaFormateada));

                    return new Date(fechaFormateada).getTime();

            },
            getDetTicketsById(idHeader, name) {
            this.listDesgloseTicket = [];
            this.nameTickets = name;

            this.loading = Loading.service({ text: "Cargando..." });

            var config = {
                params: {
                idBusiness: this.idBusiness,
                idHeader: idHeader,
                jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "sales/getDetTicketsById", config)
                .then(function(response) {
                if (response.data.response) {
                    vm.listDesgloseTicket = response.data.result[0];
                    vm.$modal.show("desglose-ticket-modal");
                } else {
                    swal({
                    title: vm.$t("atencion"),
                    text: response.data.result,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                    });
                }
                vm.loading.close();
                })
                .catch(function(error) {
                console.log(error);
                });
            },
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        //vm.getSalesOperarios();
                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getTpv() {

                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {


                          /*  for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }*/

                            vm.listCheckBoxTpv = response.data.result;


                            for (let i = 0; i < response.data.result.length; i++) {

                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }
                          //  console.log(vm.nameOperario);
                            vm.getIussesOperarios();


                        }


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getIussesOperarios() {
                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loading.close();
                } else {
                    
                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.loading.close();
                    } else {
                        if(!this.nameOperario){
                            this.loading.close();
                            this.$router.go(-1);
                        }else{

                            this.$store.dispatch("setDateTo", this.dateto);
                            this.$store.dispatch("setDateFrom", this.datefrom);

                            let idTpvAMandar = "";

                            if (this.idTpv == -1) {
                                idTpvAMandar = 0;
                            } else {
                                idTpvAMandar = this.idTpv;
                            }

                            var config = {
                                params: {
                                    idBusiness: this.idBusiness,
                                    idTpv: idTpvAMandar,
                                    datefrom: moment(this.datefrom).startOf("day").unix(),
                                    dateto: moment(this.dateto).endOf("day").unix(),
                                    jwt: this.$store.getters.jwt,
                                    nameWorker:this.nameOperario,
                                // desde: 1,
                                },
                                headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                            };

                            this.loading.close();

                            let vm = this;
                            this.$store.dispatch("setIdBusiness", this.idBusiness);
                            this.axios.get(this.$store.getters.apiUrl + "workers/getIncidenciasbyOperario", config)
                                .then(function (response) {
                                    if (response.data.response) {

                                        vm.list = response.data.result;
                                        vm.respuesta = true;

                                        
                                    }else if (response.data.response == false && response.data.rangoMayor == true) {
                                        swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                        });
                                        vm.respuesta = false;
                                    } else {
                                        swal({
                                            title: $t('accesoDenegado'),
                                            text: response.data.message,
                                            confirmButtonClass: 'btn btn-info btn-fill',
                                            type: 'error'
                                        });

                                        vm.respuesta = false;

                                    }
                                    vm.loading.close();

                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }
    .cuentaIncidencia {
        background-color: #d2322d;
        color: #fff;
        font-size: 1.2em;
        font-style: bold;
        min-width: 70px;
        margin: 6px;
        padding: 6px;
    }
    .Ticketbtn {
        background-color: #4d94ff;
        color: #fff;
        font-size: 1.2em;
        font-style: bold;
        min-width: 70px;
        margin: 6px;
        padding: 6px;
    }

    .cuentaIncidenciaIcon{
        margin-left: 8%;
        font-size: 0.8em;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/IncidenciasbyOperario.vue